/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Styles from './AppDrawer.style';
import LogoImage from 'assets/png/logo-large.png';
import { get } from 'lodash';
import { toggleAppDrawer } from '../../store/action/common-actions';
import { navLinks } from 'utils/nav-links-util';
import { Icon } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { H6, P } from 'utils/resuable-css';
import { useMutation } from 'react-query';
import { USER_STATUS } from 'queries';
import { getMenuIcon } from 'constants/menu-icon';
import { CustomAppDrawer } from '@sidraaabdullah/test-shared-library';

const AppDrawer = (props) => {
  const dispatch = useDispatch();
  const {
    isAppDrawerOpen,
    activeSectionIndex,
    activeMobileSectionIndex,
    onSectionClick,
    onMobileSectionClick,
    uiDetails,
    menuData,
  } = props;
  const [isTabVisible, setIsTabVisible] = useState(true);
  const [userStatusResult, setUserStatusResult] = useState({});
  const { mutate: userStatus } = useMutation(USER_STATUS);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabVisible(!document.hidden);
    };

    // Set up event listener for visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    let intervalId = null;

    if (isTabVisible) {
      // Trigger API call every second when tab is visible
      intervalId = setInterval(async () => {
        // Your API call code here
        await userStatus(
          {
            url_path: location?.hash?.split('#')[1],
          },
          {
            onSuccess: (e) => {
              setUserStatusResult(e);
            },
          },
        );
      }, 1000);
    }

    // Clean up interval when tab is hidden or component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [isTabVisible]);

  let url = location?.hash?.split('#')[1];

  return (
    <CustomAppDrawer
      isAppDrawerOpen={isAppDrawerOpen}
      AppDrawerSC={Styles.AppDrawerSC}
      AppDrawerHeader={
        <Styles.AppDrawerHeader href={navLinks.view_all_tickets.link} target="_blank">
          <Styles.LogoImageSC src={LogoImage} alt="logo" />
        </Styles.AppDrawerHeader>
      }
      SectionLinksContainer={
        <Styles.SectionLinksContainer>
          {menuData?.menu?.map((link, index) => {
            return (
              <Styles.SectionLink
                key={link.id}
                to={`${link.default_url}`}
                onClick={() => onSectionClick(index)}
                active={activeSectionIndex === index}
              >
                <Styles.SectionIcon
                  src={getMenuIcon(link.id)}
                  className={`box-icon ${link.id} ${activeSectionIndex === index && 'active'}`}
                />
                <Styles.SectionLabel>{link.title_en}</Styles.SectionLabel>
              </Styles.SectionLink>
            );
          })}
        </Styles.SectionLinksContainer>
      }
      MainLinksContainer={
        <Styles.MainLinksContainer>
          <div>
            {get(menuData?.menu, `${activeSectionIndex}.submenu`, []).map((link, i) => {
              if (typeof link === 'string') {
                return <Styles.Divider key={i} />;
              } else {
                return (
                  <NavLink key={i} to={link.url} className="main-link">
                    <Styles.MainLinkIcon />
                    <Styles.MainLinkLabel>{link.title_en}</Styles.MainLinkLabel>
                  </NavLink>
                );
              }
            })}

            {userStatusResult?.users_online?.length > 0 && (
              <Styles.UserStatusMain>
                <Styles.Divider />
                <H6>Users on this page:</H6>
                <Styles.UserStatusContainer>
                  {userStatusResult?.users_online?.map(
                    (val, i) =>
                      val?.user_on_url === url && (
                        <Styles.UserStatus key={i}>
                          <Icon name="circle" />
                          <div className="font">
                            {val?.staff_name} ({val?.staff_username})
                          </div>
                        </Styles.UserStatus>
                      ),
                  )}
                </Styles.UserStatusContainer>
              </Styles.UserStatusMain>
            )}
          </div>

          <Styles.UIDeatils>
            <P className="time">Time in {uiDetails?.headquarters_location}</P>
            <H6 className="date">{uiDetails?.headquarters_time}</H6>
            <H6 className="date">{uiDetails?.headquarters_date}</H6>
          </Styles.UIDeatils>
        </Styles.MainLinksContainer>
      }
      AppDrawerMobileContainer={menuData?.menu?.map((sectionLink, index) => (
        <Styles.MobileSectionLinkContainer
          key={sectionLink.id}
          active={index === activeMobileSectionIndex}
          linkCounts={sectionLink.submenu.length}
          to={`${sectionLink.default_url}`}
        >
          <Styles.MobileSectionLink
            active={index === activeMobileSectionIndex}
            onClick={() => onMobileSectionClick(index)}
          >
            {sectionLink.title_en}
            <Icon name="dropdown" />
          </Styles.MobileSectionLink>
          <Styles.MobileLinksContainer>
            {sectionLink?.submenu?.map((link) => (
              <NavLink onClick={() => dispatch(toggleAppDrawer())} key={link.id} to={link.url} className="main-link">
                <Styles.MainLinkLabel>{link.title_en}</Styles.MainLinkLabel>
              </NavLink>
            ))}
          </Styles.MobileLinksContainer>
        </Styles.MobileSectionLinkContainer>
      ))}
    />
  );
};
export default AppDrawer;
